import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	movePageBtnDesc: {
		id: 'editor-move-page-button.move.page.description',
		defaultMessage: 'Move',
		description: 'The label of move page button for unpublished draft in the editor',
	},
});
